import React from 'react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import { CustomTextField } from '../../Textfield';
import Autocomplete from '@material-ui/lab/Autocomplete';

export class PlaceAutoComplete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            address: props.defaultValue.address ?? '',
            searchedValue: '',
        };
    }

    componentDidUpdate(prevProps) {
        // Update state when defaultValue changes from parent component
        if (
            prevProps.defaultValue?.address !== this.props.defaultValue?.address
        ) {
            this.setState({ address: this.props.defaultValue?.address ?? '' });
        }
    }

    handleChange = (address) => {
        // If address is an object with address property, extract it
        if (
            typeof address === 'object' &&
            address !== null &&
            'address' in address
        ) {
            this.setState({
                address: address.address,
            });
        } else {
            this.setState({ address });
        }
    };

    handleSelect = (address) => {
        geocodeByAddress(address)
            .then((results) => {
                console.log('results', results);
                getLatLng(results[0]).then((latLng) => {
                    debugger;
                    this.props.onChange &&
                        this.props.onChange({
                            address: results[0]?.formatted_address,
                            latLng,
                            results,
                        });
                    this.setState({
                        address: results[0]?.formatted_address,
                        searchedValue: results[0]?.formatted_address,
                    });
                });
                return getLatLng(results[0]);
            })
            .then((latLng) => console.log('Success', latLng))
            .catch((error) => console.error('Error', error));
    };

    render() {
        console.log('PlacesAutocomplete', this.props);
        return (
            <PlacesAutocomplete
                value={this.state.address}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                searchOptions={{
                    componentRestrictions: { country: 'in' },
                }}
            >
                {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                }) => (
                    <Autocomplete
                        options={
                            loading
                                ? [{ description: 'Loading...' }]
                                : suggestions
                        }
                        value={this.state.searchedValue}
                        onChange={(event, newValue) =>
                            this.setState({
                                searchedValue: newValue,
                            })
                        }
                        getOptionLabel={(option) => option.description}
                        style={{ width: '100%' }}
                        disableClearable={false}
                        renderOption={(suggestion) => {
                            const className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                            // inline style for demonstration purpose
                            const style = suggestion.active
                                ? {
                                      cursor: 'pointer',
                                      width: '100%',
                                  }
                                : {
                                      cursor: 'pointer',
                                      width: '100%',
                                  };
                            return (
                                <div
                                    {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                    })}
                                >
                                    <span>{suggestion.description}</span>
                                </div>
                            );
                        }}
                        renderInput={(params) => (
                            <CustomTextField
                                {...params}
                                style={{
                                    marginBottom: '16px',
                                    '& input': { color: '#14112d' },
                                }}
                                {...getInputProps({
                                    placeholder:
                                        this.props?.defaultValue?.address ??
                                        'Search Address...*',

                                    className: 'location-search-input',
                                    error: this.props.error ?? false,
                                    helperText: this.props?.helperText ?? '',
                                })}
                                {...(!this.props?.defaultValue?.address
                                    ? {
                                          label: this?.props?.label,
                                          isRequired: this.props?.isRequired,
                                      }
                                    : {})}
                            />
                        )}
                    />
                )}
            </PlacesAutocomplete>
        );
    }
}
